/* src/app/result/add-action/add-action.component.scss */
.add-action {
  color: #6DCC09;
  line-height: 50px;
  display: flex;
  margin-top: 10px;
}
.add-action .action-text {
  display: inline-block;
  font-family: "Campton-Light";
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
}
.add-action.reminder .action-text:after {
  content: "Add Reminder";
}
.add-action .action-text:after {
  content: "Add Action";
}
.add-action .icon {
  background-image: url(/assets/img/green-add.png);
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgb(35, 37, 45);
  color: #6DCC09;
  margin-right: 10px;
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.add-action:hover {
  cursor: pointer;
}
.add-action:hover .icon {
  background-image: url(/assets/img/green-check.png);
}
.add-action.added .icon {
  background-image: url(/assets/img/black-check.png);
  background-color: #6DCC09;
}
.add-action.added.reminder .action-text:after {
  content: "Reminder added";
}
.add-action.added .action-text:after {
  content: "Action added";
}
.add-action.added:hover {
  color: white;
}
.add-action.added:hover.reminder .action-text:after {
  content: "Remove Reminder";
}
.add-action.added:hover .action-text:after {
  content: "Remove Action";
}
.add-action.added:hover .icon {
  background-color: white;
  background-image: url(/assets/img/black-remove.png);
}
.add-action.with-title {
  color: white;
  display: flex;
  margin-top: 0px;
  margin-bottom: 13px;
}
.add-action.with-title .action-text {
  display: inline-block;
  font-family: "Campton-Light";
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
  line-height: 25px;
  max-width: 473px;
}
.add-action.with-title .action-text:after {
  content: "";
}
.add-action.with-title .action-text span {
  color: white;
  display: inline-block;
  font-family: "Campton-Light";
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
}
.add-action.with-title .action-text span:hover {
  color: #6DCC09;
}
.add-action.with-title .icon {
  background-color: inherit;
  background-image: url(/assets/img/white-add.png);
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 10px;
  display: inline-block;
  width: 25px;
  height: 25px;
}
.add-action.with-title:hover {
  cursor: pointer;
}
.add-action.with-title:hover .icon {
  background-image: url(/assets/img/green-check.png);
}
.add-action.with-title.added .action-text span {
  color: #6DCC09;
}
.add-action.with-title.added .action-text:after {
  content: "";
}
.add-action.with-title.added .icon {
  background-color: inherit;
  background-image: url(/assets/img/green-check.png);
}
.add-action.with-title.added:hover .action-text span {
  color: #999999;
}
.add-action.with-title.added:hover .icon {
  background-image: url(/assets/img/grey-remove.png);
  background-color: inherit;
}
/*# sourceMappingURL=add-action.component.css.map */
